var map = {
	"./demos/basic/index.ts": 25283,
	"./demos/clickable/index.ts": 26215,
	"./demos/error/index.ts": 60817,
	"./demos/line/index.ts": 33199,
	"./demos/simple/index.ts": 65293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41623;